@if (title && !isReinsurance) {
  <div class="c__wrapper-title is-text-{{textConfig}}">
    <sd-title [titleLevel]="titleLevel" [customClass]="customClass ? customClass : 'brand--h4 is-regular'">
      <sd-html [html]="title" tag="span" />
    </sd-title>
    <ng-content select="[sd-additional-title]" />
  </div>
}

@if (isReinsurance) {
  @if (title) {
    <sd-title [titleLevel]="titleLevel" [customClass]="customClass ? customClass : 'brand--h4 is-bold'">
      <sd-html [html]="title" tag="span" />
    </sd-title>
  }
  @if (subTitle) {
    <div class="brand--h5">
      <sd-title [titleLevel]="subTitleLevel">
        <sd-html [html]="subTitle" />
      </sd-title>
    </div>
  }
  @if (description) {
    <div class="c__content">
      <sd-html [html]="description" />
    </div>
  }
}

<ng-content />
